/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_ActualInputs */

const en_audit_actual = /** @type {(inputs: Audit_ActualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actual`)
};

const es_audit_actual = /** @type {(inputs: Audit_ActualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Real`)
};

/**
* | output |
* | --- |
* | "Actual" |
*
* @param {Audit_ActualInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audit_actual = /** @type {((inputs?: Audit_ActualInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_ActualInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_actual(inputs)
	return es_audit_actual(inputs)
});